import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';
import { observable } from 'mobx';

import { findKeyByTitle, getOmniData, StrategyChannelId, StrategyImgId, strategy } from '@src/services/omni-api';
import { useEffect } from 'react';
import Toast from '@src/components/toast';
import $$tracker from '@src/tracker';
import { aLink } from '@src/utils/common-util';
import { createContentRouteUrl, isAbsoluteUrl } from '@src/utils/content-route-util';
class StrategyStore {
  dataBannerBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      pagination: {
        el: '#main-group-52',
        type: 'bullets',
        clickable: true
      },
      ...swiperOptions.default
    }
  });

  page = 1;
  pageSize = 10;

  /**
   * 最新
   * 新手
   * 门派
   * 玩法
   * 进阶
   * @type {string}
   */
  @observable currentTab = '最新';

  @observable redirect;

  @observable categoryId;

  @observable strategyList;

  @observable strategyImgList;

  /**
   * 切换tab
   * @param tab
   */
  onTabClick = tab => {
    $$tracker.clickH5GlzlNav(tab);
    this.currentTab = tab;
  };

  /**
   * 点击进入文章详情
   * @param item
   */
  onItemClick = item => {
    if (!item) {
      return;
    }
    $$tracker.clickGlzlDetails(item.title || '');
    const jumpLink = typeof item.jump_link === 'string' ? item.jump_link.trim() : '';
    if (jumpLink === 'stay') {
      return;
    }
    if (isAbsoluteUrl(jumpLink)) {
      // 置顶Banner 等条目由 CMS 直接配置完整链接(已带正确的 contentId/categoryId), 直接使用
      aLink(jumpLink);
      return;
    }
    if (jumpLink === 'link') {
      if (item.art_link?.url) {
        window.open(item.art_link.url);
      }
      return;
    }
    aLink(createContentRouteUrl('/strategy-detail', { categoryId: this.categoryId, contentId: item.contentId, page: 1 }));
  };

  /**
   * 获取轮播图
   */
  getStrategyImgList = () => {
    this.getStrategyListAsync([
      {
        dataSourceId: StrategyImgId || '',
        page: this.page,
        perPage: this.pageSize
      }
    ])
      .then(res => {
        if (res[StrategyImgId].result?.items) {
          // console.log(res);
          this.strategyImgList = res[StrategyImgId].result?.items.map(item => {
            // 保留 jump_link / art_link: 置顶Banner 的跳转地址配在 jump_link 上, 不能丢
            return {
              ...item,
              url: item.top_banner_img?.[0]?.url || '',
              contentId: item.contentId || ''
            };
          });
        }
      })
      .catch(err => {
        Toast.fail(err?.msg);
      });
  };

  getStrategyList = () => {
    this.getStrategyListAsync([
      {
        dataSourceId: this.categoryId || '',
        page: this.page,
        perPage: 6
      }
    ])
      .then(res => {
        this.strategyList = res[this.categoryId].result.items;
      })
      .catch(err => {
        Toast.fail(err?.msg);
      });
  };

  /**
   * 点击更多
   */
  onMoreClick = () => {
    $$tracker.clickH5GlzlNav('更多');
    aLink(createContentRouteUrl('/strategy-list', { categoryId: findKeyByTitle(this.currentTab, strategy) }));
  };

  getStrategyListAsync = dataSources => {
    return getOmniData(StrategyChannelId, dataSources);
  };

  constructor(options = {}) {
    Object.assign(this, options);
  }

  use() {
    useEffect(
      () => {
        if (this.currentTab) {
          this.categoryId = findKeyByTitle(this.currentTab, strategy);
          this.getStrategyList();
        }
      },
      [this.currentTab]
    );
    useMount(async () => {
      this.getStrategyImgList();
    });
  }
}

export default StrategyStore;
